import { Component } from '@angular/core';

@Component({
  selector: 'app-links',
  templateUrl: './links.component.html',
  styleUrls: [],
  standalone: false,
})
export class LinksComponent {
  userRoleCode = localStorage.getItem('roleCode');
  constructor() {}
}
